import { Link } from 'react-router-dom';
import { clinic } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-warm border-t border-line text-ink">
      <div className="max-w-container mx-auto px-5 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-care flex items-center justify-center">
                <i className="fa-solid fa-paw text-[16px] text-white"></i>
              </span>
              <span className="font-display text-cocoa text-[22px] font-semibold">Alder Veterinary Clinic</span>
            </div>
            <p className="mt-5 text-muted text-[15px] leading-relaxed max-w-[360px]">
              Thoughtful, modern veterinary care for pets and the people who love them.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-ink text-[13px] font-semibold uppercase tracking-wider">Explore</h4>
            <ul className="mt-5 space-y-3 text-[15px] text-muted">
              <li><Link to="/services" className="hover:text-ink cursor-pointer">Services</Link></li>
              <li><Link to="/about" className="hover:text-ink cursor-pointer">About</Link></li>
              <li><Link to="/#visit" className="hover:text-ink cursor-pointer">Visit</Link></li>
              <li><Link to="/book" className="hover:text-ink cursor-pointer">Book</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-ink text-[13px] font-semibold uppercase tracking-wider">Visit</h4>
            <ul className="mt-5 space-y-3 text-[15px] text-muted">
              <li>{clinic.address}</li>
              <li>{clinic.phone}</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-ink text-[13px] font-semibold uppercase tracking-wider">Hours</h4>
            <ul className="mt-5 space-y-3 text-[15px] text-muted">
              {clinic.hours.map(h => (
                <li key={h.day} className="flex justify-between gap-4"><span>{h.day}</span><span className="text-ink">{h.time}</span></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[14px] text-muted">
          <div>© {new Date().getFullYear()} Alder Veterinary Clinic. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-ink cursor-pointer">Instagram</a>
            <a href="#" className="hover:text-ink cursor-pointer">Facebook</a>
            <a href="#" className="hover:text-ink cursor-pointer">Privacy</a>
            <a href="#" className="hover:text-ink cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}